import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Programs } from '../../../project/models/programs.model';
import { keys } from 'underscore';

@Component({
  selector: 'shr-program-type-checkbox',
  templateUrl: './program-type-checkbox.component.html',
  styleUrls: ['./program-type-checkbox.component.scss']
})
export class ProgramTypeCheckboxComponent implements OnInit {
  // send the object from the parent always
  @Input()
  selectedPrograms: Programs = new Programs(true, true, true, true, true, true, true);

  @Input()
  programRestrictions: Programs = new Programs();

  @Output()
  selectionChanged: EventEmitter<void> = new EventEmitter<void>();

  programsToDisplay: string[];

  constructor() {
    this.programsToDisplay = keys(this.selectedPrograms);
  }

  ngOnInit() {
    // Hide restricted programs
    this.programsToDisplay = this.programsToDisplay
      .filter(program => !this.programRestrictions[program]);
  }

  emit() {
    this.selectionChanged.emit();
  }
}
